require('./accountDetailsSidebar.scss');

const PropTypes = require('prop-types');

//@vendors
const React = require('react');
//@commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
//@components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
//@core
const { getLanguage } = require('core/i18n').i18n;
// @ helpers
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

class AccountDetailsSideBar extends React.Component {

    getCardFieldsToShow(immAccount) {
        const plainAmountObject = getPlainAmountObject(immAccount.get('balance'));

        return [
            {
                name: 'accountDetailsSidebar-iban',
                value: immAccount.get('iban')
            },
            {
                name: 'accountDetailsSidebar-accountHolder',
                value: immAccount.get('accountHolder')
            },
            {
                name: 'accountDetailsSidebar-balance',
                value: <OneLineSymbolAmount
                    amountObject={plainAmountObject}
                    language={getLanguage()}
                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
            }
        ];
    }

    render() {
        const {immAccount} = this.props;
        const headerTitle = immAccount.getIn(['catalogData','subtype']);
        const fields = this.getCardFieldsToShow(immAccount).map(item => (
            <OKInformativeListItem key={item.name} title={item.name}>
                <span className="account-details-side-bar__field">
                    {item.value}
                </span>
            </OKInformativeListItem>
        ));

        return (
            <OKSectionBox className="account-details-side-bar">
                <div className="account-details-side-bar__title">
                    <OKBoxTitle value={headerTitle} />
                </div>
                <OKInformativeList>
                    {fields}
                </OKInformativeList>

            </OKSectionBox>
        );
    }
}

AccountDetailsSideBar.propTypes = {
    immAccount: PropTypes.object.isRequired
};

module.exports = AccountDetailsSideBar;